// Persist only request metadata. Clinical text is kept in the encrypted backend result store, never browser storage.
export function recordedAttemptKey(backend, userId, patientId, path) {
  return `scribe.recorded.v1:${encodeURIComponent(JSON.stringify([backend, userId, patientId, path]))}`;
}

export function readRecordedAttempt(key) {
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  const attempt = JSON.parse(raw);
  if (!attempt.operationId || !attempt.languageCode) throw new Error('Invalid transcription recovery record');
  return attempt;
}

export function writeRecordedAttempt(key, attempt) {
  localStorage.setItem(key, JSON.stringify({
    operationId: attempt.operationId, languageCode: attempt.languageCode,
    consultationId: attempt.consultationId,
  }));
}

export function clearRecordedAttempt(key) {
  localStorage.removeItem(key);
}
